import { ProgressContainer, SimpleModal } from '../../../../../components/core-v2'
import { SearchAssetState } from '../state/portfolio-slice'
import { Asset } from '../types'
import { AssetFinder } from './finder'

type Props = {
  onChangeSearchTerm: (term: string) => void
  onClickBackToSearch: () => void
  onInspectAsset: (id: string) => void
  onSelectAsset: (asset: Asset) => void
  onStopChoosingAsset: () => void
  state: SearchAssetState
}

export const ChooseAssetModal = ({
  onChangeSearchTerm,
  onClickBackToSearch,
  onInspectAsset,
  onSelectAsset,
  onStopChoosingAsset,
  state
}: Props) => (
  <SimpleModal>
    <ProgressContainer
      currentStep={state.status === 'finding' ? 1 : 2}
      numSteps={2}
      title="Add an asset"
      onClickClose={() => onStopChoosingAsset()}
    >
      <AssetFinder
        assetBeingInspected={state.assetBeingInspected}
        assets={state.filteredAssets}
        searchTerm={state.searchTerm}
        status={state.status}
        onChangeSearchTerm={term => onChangeSearchTerm(term)}
        onClickBackToSearch={onClickBackToSearch}
        onInspectAsset={id => onInspectAsset(id)}
        onSelectAsset={asset => onSelectAsset(asset)}
      />
    </ProgressContainer>
  </SimpleModal>
)
